<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isEnd="isEnd" :isInnovation="true" :selectedQidSmall="selectedQidSmall" @getAnswer="getAnswer"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        title: '题目1',
        small: [
          {
            id: 1,
            title: '(1)',
            desc: ['(1)请<span class="title_span">尽可能多</span>地写出这些科学实验(<span class="title_span">每个实验尽量不超过10个字</span>)，且不能与左侧文字中的实验重复。（限时5分钟）'],
            durationTime: 5,
            stemContent: [
              {
                type: 'text',
                value: '在空间站养鱼、种菜，打造太空中最精准的时钟，研制独特的新型材料，寻找新的物理规律，探索人类如何在太空长期生存……随着中国空间站在2022年建成，一大批前沿科学实验将陆续在“天宫”开展。'
              },
              {
                type: 'img',
                isSmall: true,
                value: [
                  { img: require('@/assets/exam/4-before.jpg'), showBigImg: true, imageKind: 'left#左图' },
                  { img: require('@/assets/exam/4.png'), showBigImg: true, imageKind: 'right#右图' },
                ]
              },
              {
                type: 'text',
                value: '<b>题目1：</b>如果你是一名科学研究人员，你想在中国空间站内(不包括空间站外的太空)进行哪些科学实验？'
              }
            ],
            askList: [{
              id: 1,
              type: 4,
              config: {
                noneInput: true,
                type: 1
              }
            }]
          },
          {
            id: 2,
            title: '(2)',
            durationTime: 3,
            desc: ['（2）请将你想到的科学实验按类别拖拽到相应的分类框里，如果你想到的超出列出的这几类，可以点击“+”添加新的分类框。除了已经想到的这些，你对空间站内进行的科学实验能再提出一些新想法吗？请将新想法添加到相应的分类框里。'],
            stemContent: [
              {
                type: 'array'
              }
            ],
            askList: [{
              id: 1,
              type: 8,
              typeList: [
                {
                  title: '生命科学',
                  disabled: true,
                  children: []
                },
                {
                  title: '物质科学',
                  disabled: true,
                  children: []
                },
                {
                  title: '天文与地球',
                  disabled: true,
                  children: []
                },
                {
                  title: '技术与应用',
                  disabled: true,
                  children: []
                }
              ]
            }]
          }
        ]
      }, {
        qid: 2,
        title: '题目2',
        small: [
          {
            id: 3,
            title: '(3)',
            durationTime: 7,
            desc: ['(3)请发挥你的想象力，再设计1个<span class="title_span">全新的</span>关于“水”的空间站实验，且该实验是其他同学不容易想到的，请清晰、具体地写出实验内容（包括实验目的、主要实验装置和用品、实验操作，可画出实验装置图）。'],
            stemContent: [
              {
                type: 'text',
                value: '<b>题目2：</b>以下是神舟十三号乘组航天员进行太空授课时展示的水膜张力实验，请观看视频。'
              },
              {
                id: 1,
                type: 'video',
                value: [
                  {
                    autoPlay: false,
                    isControl: true,
                    isloop: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6409c3fb22ba6/184df8d42d6588eb80b1a1eec8c81e87.mp4'
                  }
                ]
              },
            ],
            showAnswer: true,
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
              // title: '实验目的：',
              isReview: true
            }, {
              id: 2,
              type: 10,
              title: '实验装置图：'
              // title: '实验装置图：可画在下发的答题纸上。'
            }]
          }, {
            id: 4,
            title: '(4)',
            durationTime: 2,
            desc: ['（4）请说明你的这个新实验是如何想到的（或受到什么启发）。'],
            stemContent: [
              {
                type: 'text',
                value: '实验内容:'
              },
              {
                type: 'text',
                value: ''
              },
              {
                type: 'text',
                value: '设计图：'
              },
              {
                type: 'draw',
                value: 'img'
              }
            ],
            showAnswer: true,
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
              // title: '实验目的：',
            }]
          }
        ]
      }, {
        qid: 3,
        title: '题目3',
        small: [
          {
            id: 5,
            title: '(5)',
            stemContent: [
              {
                type: 'text',
                value: '<b>题目3：</b>请观看太空授课中的“水中泡腾片”实验。'
              },
              {
                type: 'video',
                id: 2,
                value: [
                  {
                    autoPlay: false,
                    isControl: true,
                    isloop: true,
                    url: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/8881de6a9c3e1eea1b05a372ad41d21c.mp4'
                  }
                ]
              }
            ],
            showAnswer: true,
            durationTime: 5,
            desc: ['（5）“水中泡腾片”实验曾因“太危险”差点取消，请分析在空间站进行该实验存在危险的原因。'],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
              isReview: true
            }]
          }, {
            id: 6,
            title: '(6)',
            stemContent: [
              {
                type: 'img',
                isSmall: true,
                value: [
                  { img: require('@/assets/exam/39.png'), showBigImg: true, imageKind: 'left#左图' },
                  { img: require('@/assets/exam/40.png'), showBigImg: true, imageKind: 'middle#中间图' },
                  { img: require('@/assets/exam/41.png'), showBigImg: true, imageKind: 'right#右图' }
                ]
              },
              {
                type: 'text',
                value: ''
              }
            ],
            showAnswer: true,
            durationTime: 5,
            desc: ['（6）请在原实验基础上改进“水中泡腾片”实验，说明具体的方案及是如何避免危险的。'],
            askList: [{
              id: 1,
              type: 3,
              img: require('@/assets/exam/6.png')
            },
            {
              id: 2,
              type: 1,
              noneInput: true,
            }],
          }
        ]
      }],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    getSmallList() {
      const list = this.qidList.reduce((list, item) => {
        list.push(...item.small)
        return list
      }, [])
      return list
    },
    getAnswer(obj) {
      const selectedQidSmall = obj.selectedQidSmall
      const smallList = this.getSmallList()
      const smallItem = smallList[selectedQidSmall]
      for (const item of smallItem.stemContent) {
        if (item.type == 'text' && item.value == '') {
          item.value = obj.text
        }
      }
      // 写死？？？！！！
      // this.qidList[1].small[1].stemContent[1].value = obj.text
      this.$forceUpdate()
    },
    async next(sonData, currentQSmall, type) {
      const num = currentQSmall % 2 === 1 ? 1 : 2
      const tab = Math.floor(currentQSmall / 2)
      const data = Object.assign({
        exam_id: 1,
        exam_num: (num === 1 ? tab + 1 : tab) + '_' + num,
        subject_id: 1,
        subject_name: '太空',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 6) {
        this.selectedQidSmall = 6
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'innovationSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
  mounted() {
    // if (sessionStorage.selectedQidSmall) {
    //   const obj = JSON.parse(sessionStorage.selectedQidSmall)
    //   if (obj.cosmodom && Number(obj.cosmodom) > 1) {
    //     this.selectedQidSmall = Number(obj.cosmodom)
    //   } else {
    //     this.selectedQidSmall = 1
    //   }
    // } else {
    //   this.selectedQidSmall = 1
    // }
  }
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
